const rankingItems = [
  { rank: 1, title: '《暗夜追踪》2026悬疑大片', tag: '新片', change: 'hot', desc: '高智商犯罪与警匪对决的极致演绎' },
  { rank: 2, title: '《山海风云录》玄幻巨制', tag: '热播', change: 'up', desc: '史诗级特效打造东方奇幻世界' },
  { rank: 3, title: '《都市恋语》浪漫爱情剧', tag: '飙升', change: 'up', desc: '甜蜜治愈的都市爱情故事' },
  { rank: 4, title: '《星际迷航：新纪元》', tag: '推荐', change: 'new', desc: '科幻迷不容错过的视觉盛宴' },
  { rank: 5, title: '《笑傲江湖之风云再起》', tag: '经典', change: 'up', desc: '武侠经典全新演绎再掀热潮' },
];

const changeIcon: Record<string, string> = {
  hot: 'ri-fire-fill text-accent-500',
  up: 'ri-arrow-up-fill text-primary-500',
  new: 'ri-sparkling-fill text-secondary-600',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center">
          热门排行
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">实时热搜影视作品榜单</p>

        <div className="mt-10 space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 font-bold font-heading text-lg ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate font-heading">
                    {item.title}
                  </h3>
                  <span className={`shrink-0 px-2 py-0.5 text-xs font-medium rounded-full ${
                    item.tag === '新片' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '热播' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '飙升' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>

              <div className="shrink-0">
                <i className={changeIcon[item.change] || 'ri-arrow-up-fill text-primary-500'}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}